module.exports = __webpack_public_path__ + "static/media/Ezugi6.b26a39dd.webp";